import { render, staticRenderFns } from "./IndonesiaFlagRounded.vue?vue&type=template&id=a31296a8"
import script from "./IndonesiaFlagRounded.vue?vue&type=script&lang=js"
export * from "./IndonesiaFlagRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports